import {NavigationTab} from '@/logged/features/aside-menu';
import {I18nService} from '@malt/vue3-i18n';
import {computed} from 'vue';
import {useUser} from '../../user';

export function useHeaderNavigationTabs() {
    const userStore = useUser();

    const currentLanguage = computed(() => userStore.user?.currentLanguage);

    const urlHelpCenter = computed(() => (userStore.hasSelectedClientIdentity ? '18214' : '18216'));
    const isFreelancerIdentity = computed(() => userStore.selectedIdentity?.type === 'FREELANCE');

    const currentCountry = computed(() => userStore.user?.currentCountry);

    const resourcesUrls: {[index: string]: string} = {
        FR: '/resources',
        'en-FR': 'https://www.malt.fr/resources',
        GB: '/resources',
        BE: '/resources',
        'en-BE': 'https://fr.malt.be/c/resources',
        DE: '/resources',
        'en-DE': 'https://www.malt.de/resources',
        ES: '/resources',
        'en-ES': 'https://www.malt.es/resources',
        NL: '/resources',
        'en-NL': 'https://www.malt.nl/resources',
        'fr-CH': 'https://www.malt.fr/resources',
    };

    const resourceUrl = computed(() => {
        if (currentLanguage.value && currentCountry && resourcesUrls[currentLanguage.value + '-' + currentCountry.value]) {
            return resourcesUrls[currentLanguage.value + '-' + currentCountry.value];
        }
        if (currentCountry.value && resourcesUrls[currentCountry.value as string]) {
            return resourcesUrls[currentCountry.value as string];
        }
        return 'https://www.malt.uk/resources';
    });

    const faqUrl = computed(() => ({
        href: `https://help.malt.com/kb/${currentLanguage.value}/${urlHelpCenter.value}`,
        blank: true,
    }));

    return computed((): NavigationTab[] => [
        {
            id: 'HelpCenter',
            title: I18nService.msg('navbar.header.tabs.help.center.title'),
            icons: {
                mainIcon: 'header/help-center',
            },
            url: isFreelancerIdentity.value ? faqUrl.value : undefined,
            children:
                userStore.selectedIdentity?.type === 'FREELANCE'
                    ? undefined
                    : [
                          {
                              id: 'faq',
                              title: I18nService.msg('navbar.header.tabs.help.center.title'),
                              icons: {
                                  mainIcon: 'header/help-center',
                              },
                              url: faqUrl.value,
                          },
                          {
                              id: 'freelancer-resources-center',
                              title: I18nService.msg('navbar.aside.tabs.title.freelancer.resources.center'),
                              icons: {
                                  mainIcon: 'aside/resources',
                              },
                              url: {href: resourceUrl.value, blank: true},
                          },
                      ],
        },
    ]);
}
